import Modal, { ModalCustomProps } from './Modal.component';

export type ModalTypes = ModalCustomProps;

export default Modal;
